import { render } from "./auth-change-expired-password.vue?vue&type=template&id=61d078e2&scoped=true"
import script from "./auth-change-expired-password.vue?vue&type=script&lang=js"
export * from "./auth-change-expired-password.vue?vue&type=script&lang=js"

import "./auth-change-expired-password.vue?vue&type=style&index=0&id=61d078e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d078e2"]])

export default __exports__